@if (open()) {
  <div class="gam-backdrop" (click)="close()"></div>
  <div #dialog class="gam" role="dialog" aria-modal="true" aria-labelledby="gam-title" aria-describedby="gam-sub">
    <button #closeButton type="button" class="gam__x" (click)="close()"
            [attr.aria-label]="i18n.t('common.close')">×</button>

    <div class="gam__body">
      <h2 id="gam-title" class="gam__title">{{ i18n.t('appModal.title') }}</h2>
      <p id="gam-sub" class="gam__sub">{{ i18n.t('appModal.sub') }}</p>

      <div class="gam__badges">
        <a class="gam-badge" [href]="playStoreUrl" target="_blank" rel="noopener" (click)="goToStore()"
           [attr.aria-label]="i18n.t('appBanner.aria')">
          <svg class="gam-badge__logo" viewBox="0 0 24 26" aria-hidden="true">
            <path d="M1.1 1.1 13.3 13 1.1 24.9C.7 24.5.5 24 .5 23.4V2.6C.5 2 .7 1.5 1.1 1.1Z" fill="#00d7fe" />
            <path d="M17.4 8.9 13.3 13 1.1 1.1c.5-.5 1.3-.6 2-.2l14.3 8Z" fill="#00f076" />
            <path d="M17.4 17.1 3.1 25.1c-.7.4-1.5.3-2-.2L13.3 13l4.1 4.1Z" fill="#f73448" />
            <path d="m22.4 11.6-5-2.7-4.1 4.1 4.1 4.1 5-2.7c1.2-.7 1.2-2.1 0-2.8Z" fill="#ffd400" />
          </svg>
          <span class="gam-badge__text">
            <small>{{ i18n.t('appModal.getItOn') }}</small>
            <strong>Google Play</strong>
          </span>
        </a>
        <!-- Not published yet: visibly inert, so nobody taps it expecting a listing. -->
        <span class="gam-badge is-soon" aria-disabled="true">
          <svg class="gam-badge__logo" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2" />
            <path d="M12 7v5l3 2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
          <span class="gam-badge__text">
            <small>{{ i18n.t('appModal.soon') }}</small>
            <strong>App Store</strong>
          </span>
        </span>
      </div>

      <!-- Desktop only (hidden on a phone, which cannot scan its own screen). -->
      <a class="gam__qr" [href]="getAppUrl" target="_blank" rel="noopener" (click)="goToStore()">
        <img src="images/common/orderyaa-get-app-qr.svg" width="88" height="88" alt="" />
        <span>{{ i18n.t('appModal.scan') }}</span>
      </a>
    </div>

    <!--
      A phone showing the shop: its red header, then a sheet of products with their pictures, names
      and prices, the way the app's own listing looks. Drawn in CSS rather than photographed, so it
      is always the CUSTOMER app it pictures, it costs no image to download, and nothing here can go
      stale. Decorative throughout — the dialog says everything in words above.
    -->
    <div class="gam__art" aria-hidden="true">
      <div class="gam-phone">
        <div class="gam-phone__notch"></div>
        <div class="gam-phone__screen">
          <img class="gam-phone__logo" appBrandLogo="customer" [onDark]="true" alt="" />
          <span class="gam-phone__search"></span>
          <div class="gam-phone__sheet">
            <span class="gam-phone__chips"><i class="is-on"></i><i></i><i></i></span>
            <div class="gam-phone__grid">
              @for (tone of [1, 2, 3, 4]; track tone; let i = $index) {
                <span class="gam-item">
                  @if (shops()[i]; as shop) {
                    <!-- Real artwork from the listing behind this popup; the browser already has it. -->
                    <img class="gam-item__pic" [class.is-mark]="shop.isMark" [src]="shop.src" alt=""
                         (error)="onPictureError(shop.key)" />
                  } @else {
                    <i [class]="'gam-item__pic gam-item__pic--' + tone"></i>
                  }
                  <i class="gam-item__name"></i>
                  <i class="gam-item__price"></i>
                </span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
